/**
 * The build version baked into this bundle at build time. Injected by CI as
 * `VITE_VERSION` (see `.azuredevops/pipelines/templates/build-app.yml`); unset
 * locally, where it falls back to the `dev` sentinel that disables the
 * new-version check.
 */
export const appVersion = import.meta.env.VITE_VERSION ?? 'dev';
